import ClientList from "./pages/ClientList";
import ClientForm from "./pages/ClientForm";
import ClientProfile from "./pages/ClientProfile";

export const clientRoutes = [
  {
    path: "/clients",
    element: <ClientList />,
    permission: "CLIENT_VIEW"
  },
  {
    path: "/clients/new",
    element: <ClientForm />,
    permission: "CLIENT_CREATE"
  },
  {
    path: "/clients/edit/:id",
    element: <ClientForm />,
    permission: "CLIENT_EDIT"
  },
  {
    path: "/clients/:id",
    element: <ClientProfile />,
    permission: "CLIENT_VIEW"
  }
];
